<dx-popup
  [width]="600"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'COMPLETE-TRAINING.MERGE-WITH-EXISTING-ACCOUNT' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [(visible)]="showModal"
  class="modal"
  [classList]="'modal'"
>
  <div *dxTemplate="let data of 'content'">
    <div class="h-100">
      <div class="warning-text">
        {{ 'COMPLETE-TRAINING.MERGE-WARNING-TEXT' | translate }}
      </div>

      <div class="attendees-list">
        <dx-form [formData]="formData" labelMode="floating">
          <dxi-item>
            <dxo-label [text]="'COMMON.SEARCH' | translate"></dxo-label>
            <div *dxTemplate>
              <dx-text-box
                icon="search"
                width="100%"
                valueChangeEvent="input"
                labelMode="floating"
                stylingMode="outlined"
                placeholder=""
                [label]="
                  'MY-TRAININGS.TRAINING-INVITE.SEARCH-IN-EMPLOYEES-AND-CONTACTS'
                    | translate
                "
                [(value)]="formData.search"
                (valueChange)="onSearchValueChanged($event)"
              >
                <dxi-button
                  name="search"
                  type="danger"
                  location="before"
                  [options]="{
                    icon: 'search',
                    type: 'default',
                    disabled: true
                  }"
                ></dxi-button>
              </dx-text-box>
            </div>
          </dxi-item>
          <dxi-item itemType="group" colCount="2">
            <dxi-item>
              <dxo-label
                [text]="'COMMON.FIELDS.LOCATIONS-DEPARTMENTS' | translate"
              ></dxo-label>
              <div *dxTemplate>
                <dx-drop-down-box
                  [(value)]="formData.organisationUnitFilter"
                  valueExpr="id"
                  displayExpr="name"
                  [label]="'COMMON.FIELDS.LOCATIONS-DEPARTMENTS' | translate"
                  [dataSource]="organisationUnits"
                  labelMode="floating"
                  stylingMode="outlined"
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      [searchEnabled]="true"
                      [dataSource]="organisationUnits"
                      dataStructure="plain"
                      keyExpr="id"
                      selectionMode="multiple"
                      showCheckBoxesMode="normal"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      [selectByClick]="true"
                      (onItemSelectionChanged)="
                        onOrganizationUnitsSelected($event)
                      "
                    >
                    </dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>
            <dxi-item>
              <dxo-label
                [text]="'COMMON.FIELDS.TRAINING-GROUPS' | translate"
              ></dxo-label>
              <div *dxTemplate>
                <dx-drop-down-box
                  [(value)]="formData.trainingGroupFilter"
                  [inputAttr]="{ 'aria-label': 'Owner' }"
                  valueExpr="id"
                  displayExpr="name"
                  [label]="'COMMON.FIELDS.TRAINING-GROUPS' | translate"
                  [dataSource]="trainingGroups"
                  labelMode="floating"
                  stylingMode="outlined"
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      [searchEnabled]="true"
                      [dataSource]="trainingGroups"
                      dataStructure="plain"
                      keyExpr="id"
                      selectionMode="multiple"
                      showCheckBoxesMode="normal"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      [selectByClick]="true"
                      (onItemSelectionChanged)="
                        onTrainingGroupSelected($event)
                      "
                    >
                    </dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>
          </dxi-item>
        </dx-form>

        <div class="available-list">
          <div class="list-wrapper" (scroll)="onScroll($event)">
            @for (person of allPersons; track person.id) {
              <div 
                class="product" 
                [class.selected]="selectedPerson?.id === person.id"
                (click)="onPersonSelected($event, person)"
              >
                <div class="info">
                  <div>
                    <div>{{ person.firstName }} {{ person.lastName }}</div>
                    <div class="email-muted">
                      {{ person.email }}
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="{
      stylingMode: 'contained',
      type: 'danger',
      text: 'COMMON.CANCEL' | translate,
      onClick: onCancelClick
    }"
  >
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
      stylingMode: 'contained',
      type: 'normal',
      text: 'EMPLOYEE.OVERVIEW.MERGE' | translate,
      disabled: !selectedPerson,
      onClick: onMergeClick
    }"
  ></dxi-popup-toolbar-item>
</dx-popup>
